import store from "../../index.js";
import SubscribeConstant from "@/mixins/subscribe/const/subscribeConstant.js";
import SubscribeAcConstant from "@/mixins/subscribe/const/subscribeAcConstant.js";

import {
  callGetApi,
  callPostApi,
  callPatchApi,
  callDeleteApi,
} from "@/utils/apiWrapper";

export const modules = {
  store,
};

export const state = {
  _offers: [],
  _error: {
    code: 0,
    message: "",
  },
};

export const mutations = {
  // 에러 처리
  [SubscribeConstant.SET_SUBSCRIBE_ERROR](state, item) {
    state._error = item;
  },
  [SubscribeConstant.SET_SUBSCRIBE_OFFER](state, item) {
    state._offers = item?.offers ?? [];
  },
};

export const actions = {
  async acSubscribeOffers({ commit }, id = null) {
    const res = await callGetApi({
      url: SubscribeAcConstant.GET_SUBSCRIBE_OFFER,
      params: { id },
      commit,
      errorMutation: SubscribeConstant.SET_SUBSCRIBE_ERROR,
    });

    commit(SubscribeConstant.SET_SUBSCRIBE_OFFER, res);
    return true;
  },
};

export const getters = {
  geCodeFail: (state) => {
    switch (state._error.code) {
      case 0:
        return "";
      default:
        return state._error.message;
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
